import styled from 'styled-components'

export const Wrap = styled.div`
  width: 100%;
  height: 100dvh;
  padding-top: var(--header-h-mobile, 75px);
  background: #000;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  position: fixed;
  inset: 0;
  z-index: 100;
`

export const TopBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  flex-shrink: 0;
`

export const BackBtn = styled.button`
  display: flex;
  align-items: center;
  gap: 4px;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
  background: none;
  border: none;
  padding: 0;
`

export const Controls = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`

export const ControlBtn = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.1);
  border: none;
  color: #fff;
  cursor: pointer;
`

export const GameFrame = styled.iframe`
  width: 100%;
  margin: 0 auto;
  flex: 1;
  border: none;
  background: #000;
  display: block;
`
